import React, { useState, useEffect, useMemo} from 'react';
import { resetHeight } from '../functions/ResetHeight';
import FeaturePlan from './GetStarted/FeaturePlan';
import { Plan } from './types';
import { useAppDispatch } from '../../stores/hook';
import language from '../../utils/LanguageSettings';
import { useSearchParams } from 'react-router-dom';
import { fetchGetStartedBox } from '../functions/fetchGetStarted';
import SubscribeModal from './GetStarted/Modals/SubscribeModal/SubscribeModal';
import PackModal from './GetStarted/Modals/PackModal';
import { setIsRecommendationPage } from './GetStarted/GetStartedSlice';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';

interface SubscribeRecommendationProps {

}

const SubscribeRecommendation: React.FC<SubscribeRecommendationProps> = () => {
  const [featurePlans, setFeaturePlans] = useState<Plan[]>([]);
  const [allFeaturePlans, setAllFeaturePlans] = useState<Plan[]>([]);
  const [comboPacks, setComboPacks] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const h1_title = window.myAppStrapi && window.myAppStrapi.h1_title ? window.myAppStrapi.h1_title : '';
  const subtitle = window.myAppStrapi && window.myAppStrapi.subtitle ? window.myAppStrapi.subtitle : '';
  const subtitle_2 = window.myAppStrapi && window.myAppStrapi.subtitle_2 ? window.myAppStrapi.subtitle_2 : '';
  const add_on_link = window.myAppStrapi && window.myAppStrapi.add_on_link ? window.myAppStrapi.add_on_link : {};
  const addOnLinkMap = new Map(Object.entries(add_on_link));

  const bottom_text_id = window.myAppStrapi && window.myAppStrapi.bottom_text_id ? window.myAppStrapi.bottom_text_id : '';
  const bottom_text = window.myAppStrapi && window.myAppStrapi.bottom_text ? window.myAppStrapi.bottom_text : '';
  const bottom_button_link_url = window.myAppStrapi && window.myAppStrapi.bottom_button_link_url ? window.myAppStrapi.bottom_button_link_url : '';
  const bottom_button_link = window.myAppStrapi && window.myAppStrapi.bottom_button_link ? window.myAppStrapi.bottom_button_link : {};
  const bottomButtonLinkMap = new Map(Object.entries(bottom_button_link));


  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const libid = searchParams.get('libid');
  const channelid = searchParams.get('channelid');
  dispatch(setIsRecommendationPage(true));
  useEffect(() => {
    resetHeight();
  });

  useEffect(() => {
    const fetchData = async () => {
        let data = await fetchGetStartedBox(language);
        if(data){
          setComboPacks(data.combopacks);
          setAllFeaturePlans(data ? (data.plans ? data.plans : []) : []);
          setLoading(false);
        }
    };
    fetchData();
  }, [language]);

  useEffect(() => {
    if (comboPacks.length > 0 && allFeaturePlans.length > 0) {
      setFeaturePlans(getFilteredPlans());
    }
  }, [comboPacks, allFeaturePlans]);
  
  const getFilteredPlans = () => {
    console.log(allFeaturePlans);
    let filterPlans: Plan[] = [];
    // only show plans that have priceOption which at least one price is valid
    allFeaturePlans.forEach(plan => {
      if (plan.attributes.PriceOptionsSTB && plan.attributes.PriceOptionsSTB.length > 0) {
        const filterPriceOptions = plan.attributes.PriceOptionsSTB.filter(priceOption => {
          return typeof priceOption.Price === 'number' && priceOption.Price >= 0
        });
        if (filterPriceOptions.length > 0) {
          plan.attributes.PriceOptions = filterPriceOptions;
          filterPlans.push(plan);
        }
      }
    });
    const filterData: any = [];
    if (filterPlans.length > 0) {
      const packsData = comboPacks.map((pack: any) => pack.attributes);
        if (libid) {
          console.log("Filter: library " + libid);
          // filter library
          for (const pack of packsData) {
            const libNumbArray = pack?.onDemandNumber?.data;
            if (libNumbArray) {
              const libNumbsOfPack = libNumbArray.map((item: any) => item.attributes.number);
              // if the pack has the library, add all plans of the pack
              if (libNumbsOfPack.includes(libid)) {
                const planIdsInPack = pack?.plans?.data?.map((plan: { id: any }) => plan.id);
                for (const plan of filterPlans) {
                  if (planIdsInPack && planIdsInPack.includes(plan.id)) {
                    filterData.push(plan)
                  }
                }
              }
            }
          }
        } else if (channelid) {
          console.log("Filter channel: " + channelid);
          // filter channel
          for (const pack of packsData) {
            const channelNumbArray = pack?.channelsNumber?.data;
            if (channelNumbArray) {
              const channelNumbsOfPack = channelNumbArray.map((item: any) => item.attributes.number);
              // if the pack has the channel, add all plans of the pack
              if (channelNumbsOfPack.includes(channelid)) {
                const planIdsInPack = pack?.plans?.data?.map((plan: { id: any }) => plan.id);
                for (const plan of filterPlans) {
                  if (planIdsInPack && planIdsInPack.includes(plan.id)) {
                    filterData.push(plan)
                  }
                }
              }
            }
          }
        }
      }
      return [...new Set(filterData.map((item: any) => JSON.stringify(item)))].map((item: any) => JSON.parse(item));
    };

    const redirectToUrl = (link: string) => {
      const d = new Date();
      d.setTime(d.getTime() - 30 * 24 * 60 * 60 * 1000);
      document.cookie = `cpm=; expires=${d.toUTCString()}; SameSite=None; Secure; domain=.nowtv.now.com; path=/`;
      window.location.href = link;
    }

      if (loading) {
        return (<>
            <div id="loader">
                <div className="spinner-border"></div>
            </div>
        </>
        );
    }
    return (
      <>
        <section id="main-content">
          <div className="container">
            <div className="introduction-text text-center" style={{margin:0}}>
              <h1 className="section-title mb-3 pb-1 font-medium">
                <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]} components={{p: React.Fragment,}}>{h1_title}</ReactMarkdown>
              </h1>
              <h4 className="subtitle">
                <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]} components={{p: React.Fragment,}}>{subtitle}</ReactMarkdown>
              </h4>
              <h5 className="subtitle-2">
                <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]} components={{p: React.Fragment,}}>{subtitle_2}</ReactMarkdown>
              </h5>
            </div>
            <div className="get-started-wrapper">
              <div className="container">
                <div className="plan-wrapper" style={{margin: 0}}>
                  <FeaturePlan plans={featurePlans} />
                </div>
              </div>
            </div>
            {addOnLinkMap.get("title") ? 
            <p className="text-center mb-0">
              <a onClick={() => redirectToUrl(addOnLinkMap.get("url"))} data-text={addOnLinkMap.get("title")+">>"} className="arrowed-link lg_font_size" target={addOnLinkMap.get("target") ? addOnLinkMap.get("target") : "_self"}>
                  {addOnLinkMap.get("title")}
                <i className="icon-angle-right"></i>
              </a>
            </p>
            : <></>}
            {bottom_text_id ? <p className="text-center barlow-font pb-5 pt-4 light-gray legend-text">{bottom_text_id}</p> : <></>}
          </div>
            
            {bottom_text && bottomButtonLinkMap.get("title") ?
            <div className="light-gray-bg text-center py-4">
              <div className="container-fluid">
                  <h5 className="font-medium d-md-inline-block d-block mb-md-0 mb-4 align-middle">
                      {bottom_text}
                  </h5>
                  <a onClick={() => redirectToUrl(bottom_button_link_url)} className="default-bordered-btn ml-md-5 ml-0">{bottomButtonLinkMap.get("title")}</a>
              </div>
            </div>
            :<></>}
            <PackModal />
            <SubscribeModal />
        </section>
      </>
      );
};

export default SubscribeRecommendation;